<template lang="pug">

    div
      div( v-if="loading" ) Loading matrix...
      div( v-else )
        div( v-if="audit.closedMerchant") 
          span( class="badge badge-secondary" ) Closed
        div( v-else-if="audit.manualReviewRequired && audit.advertiserSnapshot && audit.advertiserSnapshot.cannotAudit")
          span( class="badge badge-secondary" ) MR (Advertiser setting)
        div( v-else-if="audit.manualReviewRequired")
          span( class="badge badge-secondary" ) Manual review
        div( v-else-if="audit.status === 'FAILED' && ! audit.hasAlp" ) Not Audited
        div( v-else-if="audit.network === 'null'" )
          span( class="badge badge-secondary" ) Null
        div( v-else )
          div
            span( v-bind:class="`badge badge-${getHandoverImpactLabel('alp')}`" v-html="getErrorStatusesForStage('alp')" )  
          div( v-if="audit.hasPostConsentJourney" )
            span( v-bind:class="` badge badge-${getHandoverImpactLabel('alp-post-consent')}`" v-html="getErrorStatusesForStage('alp-post-consent')" ) 
          div( v-if="audit.hasPostConsentRefreshJourney" )
            span( v-bind:class="` badge badge-${getHandoverImpactLabel('alp-post-consent-refresh')}`" v-html="getErrorStatusesForStage('alp-post-consent-refresh')" )

</template>

<style lang="scss" scoped>
.table-list {
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.status-cell {
  vertical-align: middle;
  
}
.btn-details {
  margin-bottom: 0 !important;
}
.badge-empty {
  width: 25px;
  height: 20px;
  font-size: 0%;
  vertical-align: middle;

}
td {
  word-break: break-all;
}
.actions-col {
  width: 180px;
}
.screenshot-thumbnail {
  width: 200px;
  height: 200px;
}
.issue-copy {
  white-space: pre-line;
}
.details-col {
  width: 240px;
}
tbody tr.outdated {
  td:first-child {
    position: relative;

    &::before {
      content: '';
      
      display: block;
      width: 5px;
      height: 102%;
      
      position: absolute;
      top: 0;
      left: 15px;

      background-color: #0c2556;
    }
  }
}
.health-check {
  table {
    tr.health-check-sub {
      td {
        font-size: 0.9em;
      }
    }
  }
}
.filter-title-bar {
  cursor: pointer;
}
</style>

<script>
import Vue from 'vue'
export default Vue.extend({
  
  props: [ 'audit' ],

  data() {
    return {
      loading: true,
      platformContent: null,
      networkErrorCodes: null,
    }
  },

  methods: {

    getTrackingLikelihood(stage) {
      if (this.audit.manualReviewRequired) {
        return 'MR'
      }
      const handoverImpact =
        (stage === 'alp') ? this.audit.handoverImpact :
        (stage === 'alp-post-consent') ? this.audit.handoverImpactPostConsent :
        (stage === 'alp-post-consent-refresh') ? this.audit.handoverImpactPostConsentRefresh : null
      if (isNaN(handoverImpact)) {
        return 'Unknown'
      }
      return Math.max(0, 100 - handoverImpact)
    },

    getHandoverImpactLabel(stage) {
      if (this.audit.manualReviewRequired) {
        return 'secondary'
      }

      const handoverImpact =
        (stage === 'alp') ? this.audit.handoverImpact :
        (stage === 'alp-post-consent') ? this.audit.handoverImpactPostConsent :
        (stage === 'alp-post-consent-refresh') ? this.audit.handoverImpactPostConsentRefresh : null

      if (isNaN(handoverImpact)) {
        return 'secondary'
      }
      else if (handoverImpact >= this.platformContent.handoverImpactThresholdCritical) {
        return 'danger'
      }
      else if (handoverImpact >= this.platformContent.handoverImpactThresholdWarning) {
        return 'warning'
      }
      return 'primary'
    },

    getErrorStatusesForStage(stage) {
      const errorPrefix =
        (stage === 'alp') ? '5' :
        (stage === 'alp-post-consent') ? '6' :
        (stage === 'alp-post-consent-refresh') ? '7': null

      if (! errorPrefix || ! this.audit.moonpullErrors) {
        return 'N/A'
      }
      const networkErrors = this.networkErrorCodes.find(n => n.network === this.audit.network)
      return `
        ${(networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`)) ? ((this.audit.moonpullErrors.find(e => e.moonpullErrorId === `${errorPrefix}.3`) ? 'N' : 'OK')) : 'N/A'}
        <strong>${((this.audit.cmpId === null && errorPrefix !== '5') ? '-' : (this.audit.moonpullErrors.find(e => e.moonpullErrorId === `${errorPrefix}.4`) ? 'N' : 'OK'))}</strong>
        ${(((this.audit.cmpId === null && errorPrefix !== '5') || this.audit.moonpullErrors.find(e => e.moonpullErrorId === `${errorPrefix}.4`)) ? '-' : (this.audit.moonpullErrors.find(e => e.moonpullErrorId === `${errorPrefix}.5`) ? 'N' : 'OK'))}
      `
    },

  },

  async beforeCreate() {
    this.platformContent = await this.$moonpull.getPlatformContent()
    this.networks = await this.$moonpull.getNetworks()
    this.networkErrorCodes = this.networks.map(network => {
      const errorCodes = []
      const stages = [ 'niu', 'nir', 'air', 'alp', 'alp-post-consent', 'alp-post-consent-refresh' ]
      stages.forEach(stage => {
        if (network.successCriteria[stage]) {
          if (network.successCriteria[stage].query) {
            errorCodes.push(...network.successCriteria[stage].query.map(q => [ q.moonpullErrorCodeForKey, q.moonpullErrorCodeForValue ]).flat())
          }
          if (network.successCriteria[stage].cookies) {
            errorCodes.push(...network.successCriteria[stage].cookies.map(q => [ q.moonpullErrorCodeForKey, q.moonpullErrorCodeForValue ]).flat())
          }
          if (network.successCriteria[stage].scripts) {
            errorCodes.push(...network.successCriteria[stage].scripts.map(q => q.moonpullErrorCode))
          }
          if (network.successCriteria[stage].extracted) {
            errorCodes.push(...network.successCriteria[stage].extracted.map(q => q.moonpullErrorCode))
          }
        }
      })
      return {
        network: network.name,
        errorCodes
      }
    })
    this.loading = false
  }
})
</script>
